/**
 * Product Tours sidebar list helpers: visibility, FOC Notes nesting, and search.
 */

export type ProductTourNavItem = {
  id: string;
  label: string;
  to: string;
  icon: string;
  /** Extra tokens matched by the sidebar search (e.g. "4.1", "FOC"). */
  keywords?: string[];
  lockTooltip?: string;
  /** When set, render a nested FOC Feedback Notes row under this tour. */
  focFeedbackTourLabel?: string;
};

export const FOC_FEEDBACK_NOTES_LABEL = 'FOC Feedback Notes';

export function productTourMatchesQuery(
  item: ProductTourNavItem,
  query: string
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const haystack = [
    item.label,
    ...(item.keywords ?? []),
    ...(item.focFeedbackTourLabel
      ? [FOC_FEEDBACK_NOTES_LABEL, 'FOC Feedback', item.focFeedbackTourLabel]
      : []),
  ]
    .join(' ')
    .toLowerCase();
  return haystack.includes(q);
}

export function filterProductTourNavItems(
  items: ProductTourNavItem[],
  query: string
): ProductTourNavItem[] {
  return items.filter((item) => productTourMatchesQuery(item, query));
}
